import type { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { fromReminderEntityWireValue } from "web_myplann/Reminders/Config/reminderEntityWireValues";
import { z } from "zod";

// `data` u reminder položek je volné pole, ne DTO: BE do něj dává hodnotu enumu
// ("portfolio") a entityId jako číslo - viz reminderEntityWireValues.ts.
const entityTypeSchema = z
	.string()
	.transform(fromReminderEntityWireValue)
	.refine(
		(entityType): entityType is ReminderEntityTypeEnum => entityType !== null,
	);

const reminderDataSchema = z.object({
	reminderId: z.number().nullish(),
	// entityType stays required — without it we cannot build the route
	// (current behavior: skip navigation).
	entityType: entityTypeSchema,
	entityId: z.union([z.string(), z.number()]).transform(String).nullish(),
});

export type ReminderData = z.infer<typeof reminderDataSchema>;

export const parseReminderData = (data: unknown): ReminderData | null => {
	const result = reminderDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
